/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * later: after the current turn. asap: at the agent’s next step. now: interrupt it.
 */
export enum AgentDeliver {
  later = 'later',
  asap = 'asap',
  now = 'now'
}
